import React, {useState, useEffect, useContext} from 'react';
import {Context} from '../../../Helpers/Auth';
import {useHistory} from 'react-router-dom';

import {useTranslation} from 'react-i18next';

import SelectComponent from '../../Selects/SelectComponent';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import Datepicker from 'react-tailwindcss-datepicker';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from 'react-toastify';
import Spinner from '../../../components/Spinner';
import moment from 'moment';

import {
    getCategoriasReunioes,
    getEstabelecimentos,
    getNegociosPorId,

    //getReuniao,
    postContacto,
    PostDadosContaPesquisa,
    putReuniao,
    getContactosProspect,
    getProspectId,
    getRepresentantes,
} from '../../../pages/requests';

import {Datetimepicker, Input, initTE} from 'tw-elements';
import {getLeads} from '../../Leads/api';
import {gravarReuniao, getReuniao} from '../api';
import LoadingModal from '../../LoadingModal';
initTE({Datetimepicker, Input});

function NovoAgendamento({
    setShowForm,
    setGuardar,
    guardar,
    setOnChangeForm,

    agendaSelecionada,

    editarAgendamentos,
    setEditarAgendamentos,
    onChangeForm,
}) {
    const FORMATO_DATA = 'YYYY-MM-DD';

    const {t} = useTranslation();
    const {utilizador, userRepresentante, oficina} = useContext(Context);
    // const [respRecebido, setRespRecebido] = useState('');
    const [titulo, setTitulo] = useState('');

    const [negocio, setNegocio] = useState(null);
    const [empresa, setEmpresa] = useState('');
    const [estabR, setEstabR] = useState(oficina);

    const [negocios, setNegocios] = useState([]);
    const [estabelecimentos, setEstabelecimentos] = useState([]);
    const [responsaveis, setResponsaveis] = useState([]);

    const history = useHistory();

    // VALIDAÇÕES

    const [validacaoDepartamento, setValidacaoDepartamento] = useState(false);
    const [validacaoContacto, setValidacaoContacto] = useState(false);
    const [validacaoCategoria, setValidacaoCategoria] = useState(false);
    const [validacaoDtI, setValidacaoDtI] = useState(false);
    const [validacaoDtF, setValidacaoDtf] = useState(false);
    const [validacaoHrI, setValidacaoHrI] = useState(false);
    const [validacaoHrF, setValidacaoHrF] = useState(false);
    const [validacaoDesc, setValidacaoDesc] = useState(false);
    const [validacaoRep, setValidacaoRep] = useState(false);

    const [contactos, setContactos] = useState([]);
    const [contactoR, setContactoR] = useState(null);
    const [novoContacto, setNovoContacto] = useState(false);
    const [nomeR, setNomeR] = useState('');
    const [apelidoR, setApelidoR] = useState('');
    const [telemovelR, setTelemovelR] = useState('');

    const [categoria, setCategoria] = useState(null);
    const [contas, setContas] = useState([]);
    const [empresaR, setEmpresaR] = useState(null);
    const [obteveResps, setObteveResps] = useState(false);
    const [categorias, setCategorias] = useState('');
    const [respRV, setRespRV] = useState(userRepresentante);
    const [loading, setLoading] = useState(true);
    const [cliente, setCliente] = useState('');
    // const [id, setId] = useState('');

    const [showExitModal, setShowExitModal] = useState(false);
    const [loadingM, setLoadingM] = useState(false);

    const [v1, setV1] = useState(false);
    const [inputHoraInicial, setInputHoraInicial] = useState(moment().format('HH:mm'));

    const [inputHoraFinal, setInputHoraFinal] = useState('');
    const [startDate, setStartDate] = useState({
        startDate: moment().format(FORMATO_DATA),
        endDate: moment().format(FORMATO_DATA),
    });
    const [endDate, setEndDate] = useState({
        startDate: null,
        endDate: null,
    });

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const handleLeavePage = event => {
        debugger;
        if (onChangeForm) {
            setShowExitModal(true);
            if (event?.preventDefault) {
                event?.preventDefault();
            }
            return false;
        }
        return true;
    };

    useEffect(() => {
        const unblock = history.block(handleLeavePage);

        window.addEventListener('beforeunload', handleLeavePage);

        return () => {
            unblock();
            window.removeEventListener('beforeunload', handleLeavePage);
        };
    }, [onChangeForm]);

    useEffect(async () => {
        if (guardar) {
            await GuardarReuniao();
            setGuardar(false);
        }
    }, [guardar]);

    useEffect(() => {
        getRepresentantes(lang).then(res => {
            setResponsaveis(res.data.representantes);
            setObteveResps(true);
        });
    }, []);
    useEffect(() => {
        if (!utilizador) {
            return;
        }

        getEstabelecimentos(lang).then(function (response) {
            setEstabelecimentos(response.data.estabelecimentos);
        });

        getCategoriasReunioes(lang).then(res => {
            setCategorias(res.data.categorias);
        });
    }, [utilizador]);

    useEffect(() => {
        const idRecebido = agendaSelecionada?.id;
        getCategoriasReunioes(lang).then(res => {
            setCategorias(res.data.categorias);
        });

        if (agendaSelecionada) {
            setLoading(true);
            getReuniao(idRecebido, lang).then(res => {
                if (res.data.success == true) {
                    setCliente(res.data.reuniao.cliente);
                    // setId(res.data.reuniao.id);

                    if (res.data.reuniao.horaInicio.length === 4) {
                        setInputHoraInicial(res.data.reuniao.horaInicio.slice(0, 2) + ':' + res.data.reuniao.horaInicio.slice(2));
                    } else {
                        setInputHoraInicial(res.data.reuniao.horaInicio);
                    }

                    if (res.data.reuniao.horaFim.length === 4) {
                        setInputHoraFinal(res.data.reuniao.horaFim.slice(0, 2) + ':' + res.data.reuniao.horaFim.slice(2));
                    } else {
                        setInputHoraFinal(res.data.reuniao.horaFim);
                    }

                    setEndDate({
                        startDate: moment(res.data.reuniao.dataF).format(FORMATO_DATA),
                        endDate: moment(res.data.reuniao.dataF).format(FORMATO_DATA),
                    });
                    setStartDate({
                        startDate: moment(res.data.reuniao.dataI).format(FORMATO_DATA),
                        endDate: moment(res.data.reuniao.dataI).format(FORMATO_DATA),
                    });

                    setCategoria(res.data.reuniao.categoria);

                    setEmpresaR({
                        value: res.data.reuniao.cliente,
                        label: res.data.reuniao.clienteDescicao,
                    });
                    setEmpresa(res.data.reuniao.cliente);

                    setTitulo(res.data.reuniao.descicao);

                    setEstabR({
                        value: res.data.reuniao.estabelecimento,
                        label: res.data.reuniao.estabelecimentoDescricao,
                    });
                    setRespRV(res.data.reuniao.representante);

                    setContactoR(res.data.reuniao.contacto);
                }
            });
        }
        setLoading(false);
    }, [agendaSelecionada]);

    useEffect(() => {
        if (empresa) {
            getContactosProspect(empresa, lang).then(res => {
                setContactos(res.data.contactos);
                if (res.data.contactos.length > 0) {
                    setNovoContacto(true);
                }
            });
        } else {
            if (!history.location.state?.prospect) {
                getLeads(lang, 0, 99999).then(res => {
                    setContactos(res.data.leads);
                });
            }
        }
    }, [empresa]);

    // obter a listagem de negocios para o cliente
    useEffect(() => {
        if (empresaR) {
            //Filtrar os negócios de acordo com a empresa selecionada
            getNegociosPorId(empresaR.value).then(res => {
                if (res.data.success) {
                    if (res.data.negocios.length != 0) {
                        var comps = [];
                        res.data.negocios?.forEach(element => {
                            const negocio = {
                                value: element.id,
                                label: element.descricao,
                            };
                            comps.push(negocio);
                        });
                        setNegocios(comps);
                    } else {
                        setNegocios([]);
                    }
                }
            });
        } else {
            setNegocios([]);
        }
    }, [empresaR]);

    useEffect(() => {
        // se no historico tenho informação de lead, é porque vim de um lead e é para criar um agendamento para esse lead
        if (history.location.state?.lead) {
            setRespRV(history.location.state.lead.representante);
            setContactoR(history.location.state?.lead);
        }

        // se no historico tenho informação de prospect, é porque vim de um prospect e é para criar um agendamento para esse prospect
        if (history.location.state?.prospect) {
            setEmpresaR({
                value: history.location.state.prospect.codigoCliente,
                label: history.location.state.prospect.nomeCliente,
            });
            setEmpresa(history.location.state.prospect.codigoCliente);

            setRespRV(history.location.state.prospect.responsavel);

            setOnChangeForm(true);

            setNomeR('');
            setApelidoR('');
            setTelemovelR('');
            setV1(true);
            setEditarAgendamentos(true);
        }

        // se no historico tenho informação de um negocio, é porque vim de um negocio e é para criar um agendamento para esse negocio
        if (history.location.state?.negocio) {
            var _negocio = history.location.state?.negocio;
            setEmpresaR({
                value: _negocio.codEmpresa,
                label: _negocio.empresa,
            });
            setEmpresa(_negocio.codEmpresa);
            setNegocio({value: _negocio.num, label: _negocio.nome});
            setRespRV(_negocio.responsavel);

            setOnChangeForm(true);

            setNomeR('');
            setApelidoR('');
            setTelemovelR('');
            setV1(true);
            setEditarAgendamentos(true);
        }
    }, [history]);

    function GetContas(pesquisa) {
        if (pesquisa.length >= 3) {
            PostDadosContaPesquisa(pesquisa.toUpperCase()).then(res => {
                let dados = res.data;
                if (dados.success) {
                    var comps = [];
                    res.data.conta?.forEach(element => {
                        const contas = {
                            value: element.id,
                            label: element.descricao,
                        };
                        comps.push(contas);
                    });
                    setContas(comps);
                }
            });
        } else {
            setContas([]);
        }
    }

    async function GuardarReuniao() {
        var podeGravar = true;
        setLoadingM(true)
        if (!estabR) {
            setValidacaoDepartamento(true);
            podeGravar = false;
        }
        if (!titulo) {
            setValidacaoDesc(true);
            podeGravar = false;
        }
        if (!contactoR) {
            setValidacaoContacto(true);
            podeGravar = false;
        }
        if (!categoria) {
            setValidacaoCategoria(true);
            podeGravar = false;
        }
        if (!startDate.startDate) {
            setValidacaoDtI(true);
            podeGravar = false;
        }
        if (!endDate.startDate) {
            setValidacaoDtf(true);
            podeGravar = false;
        }
        if (!inputHoraFinal) {
            setValidacaoHrF(true);
            podeGravar = false;
        }
        if (!inputHoraInicial) {
            setValidacaoHrI(true);
            podeGravar = false;
        }
        if (!respRV) {
            setValidacaoRep(true);
            podeGravar = false;
        }

        if (moment(endDate.startDate + ' ' + inputHoraFinal).isBefore(moment(startDate.startDate + ' ' + inputHoraInicial))) {
            setValidacaoDtI(true);
            setValidacaoDtf(true);
            setValidacaoHrI(true);
            setValidacaoHrF(true);
            podeGravar = false;
            toast.warn(t('validacaoDataHora'), {
                position: 'top-right',
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
        }

        if (!podeGravar) {
             setLoadingM(false)
            toast.warn(t('preenchaCampos'), {
                position: 'top-right',
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
            return;
        }

        var r = {
            id: agendaSelecionada?.id ?? '',
            cliente: empresaR?.value,
            projeto: negocio?.value,
            estabelecimento: estabR.value,
            dataI: startDate.startDate,
            dataF: endDate.startDate,
            horaInicio: inputHoraInicial,
            horaFim: inputHoraFinal,
            categoria: categoria,
            contacto: contactoR,
            descicao: titulo,
            representante: respRV,
        };

        const guardarConclusaoWS = new Promise((resolve, reject) => {
            gravarReuniao(r, lang).then(res => {
                if (res.data.success) {
                    resolve('Sucesso!');
                } else {
                    let mensagem = res.data.error_object.errorMessages;
                    let resposta = '';
                    if (mensagem) resposta = mensagem;
                    if (!mensagem) resposta = t('toastErro');
                    reject(resposta);
                }
            });
        });
        toast.promise(
            guardarConclusaoWS,
            {
                // pending: t('a_guardar'),
                success: {
                    render({data}) {
                        setLoadingM(false)
                        if (history.location.state?.negocio) {
                            history.push(`NegociosEtapas`, {
                                negocio: history.location.state?.negocio,
                            });
                        }
                        setShowForm(false);
                        return agendaSelecionada?.id ? t('reuniaoAlterada') : t('reuniaoCriada');
                    },
                },
                error: {
                    render({data}) {
                        setLoadingM(false)
                        return data;
                    },
                },
            },
            {autoClose: 6000},
        );

        // para poder alterar states de qualquer coisa tenho que ter a promise concluida, senão o toast nunca desaparece
        // por isso tenho de fazer um await
        await Promise.allSettled([guardarConclusaoWS]);
    }

    return (
        <>
            {loading && (
                <div className="flex flex-row mt-14 justify-center">
                    <>
                        <Spinner />
                    </>
                </div>
            )}
            {loadingM && <LoadingModal />}
            {!loading && (
                <form>
                    <div className="mb-3">
                        <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('departamento')}*
                        </label>
                        <SelectComponent
                            isDisabled={!editarAgendamentos}
                            options={estabelecimentos}
                            value={estabR}
                            onChange={e => {
                                setEstabR(e);
                                setValidacaoDepartamento(false);
                                setOnChangeForm(true);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                        {validacaoDepartamento && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                    </div>
                    <div className="grid gap-6 mb-3 md:grid-cols-2">
                        <div>
                            <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('empresa')}
                            </label>
                            <SelectComponent
                                isDisabled={!editarAgendamentos}
                                options={contas}
                                value={empresaR}
                                onChange={e => {
                                    setOnChangeForm(true);
                                    setEmpresaR(e);
                                    setEmpresa(e.value);
                                    setContactoR(null);
                                    setNomeR('');
                                    setApelidoR('');
                                    setTelemovelR('');
                                    setV1(true);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('pesquisa')}
                                onInputChange={e => GetContas(e)}
                            />
                        </div>
                        <div>
                            <label htmlFor="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('negocio')}
                            </label>
                            <SelectComponent
                                isDisabled={!editarAgendamentos}
                                options={negocios}
                                value={negocio}
                                onChange={e => {
                                    setOnChangeForm(true);
                                    setNegocio(e);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('selecioneOpcao')}
                            />
                        </div>
                    </div>
                    {
                        <div className="grid gap-6 mb-3 md:grid-cols-7">
                            <div className="col-span-7">
                                <label htmlFor="phone" className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white `}>
                                    {t('contacto')}*
                                </label>
                                <SelectComponent
                                    isDisabled={!editarAgendamentos}
                                    options={contactos}
                                    value={contactoR}
                                    onChange={e => {
                                        setOnChangeForm(true);
                                        setContactoR(e);
                                        setNomeR('');
                                        setApelidoR('');
                                        setTelemovelR('');
                                        setValidacaoContacto(false);
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                    placeholder={t('selecioneOpcao')}
                                />
                                {validacaoContacto && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                            </div>
                            {/* <div className="flex justify-center items-center ">
                                <button
                                    className="flex items-center justify-center border-gray-300 text-blue-800 bg-gray-100 hover:bg-gray-300 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm text-center dark:bg-blue-600 dark:text-white dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                                    onClick={() => {
                                        setNovoContacto(true);
                                    }}>
                                    <AddOutlinedIcon />
                                </button>
                            </div> */}
                        </div>
                    }
                    {/* {visibilidadeN ? (
                        <div className="grid gap-6 mb-3 md:grid-cols-7">
                            {contactos.length != 0 &&
                            !visibilidadeC &&
                            novoContacto ? (
                                <div className="flex justify-center items-center ">
                                    <button
                                        className="flex items-center justify-center border-gray-300 text-blue-800 bg-gray-100 hover:bg-gray-300 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm text-center dark:bg-blue-600 dark:text-white dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                                        onClick={() => {
                                            setNovoContacto(false);
                                        }}>
                                        <ArrowBackRoundedIcon />
                                    </button>
                                </div>
                            ) : null}
                            <div className="flex flex-col col-span-2">
                                <label
                                    htmlFor="first_name"
                                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('nome')}*
                                </label>

                                <input
                                    type="text"
                                    value={nomeR}
                                    id="nome"
                                    className={` border  border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                        validacaoContacto
                                            ? 'dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500'
                                            : ''
                                    } ${
                                        !editarAgendamentos
                                            ? 'bg-gray-50 dark:bg-gray-800'
                                            : 'bg-white dark:bg-gray-900'
                                    }`}
                                    maxLength={20}
                                    onChange={e => {
                                        setOnChangeForm(true);
                                        setNomeR(e.target.value);
                                        setContactoR('');
                                        setValidacaoContacto(false);
                                    }}
                                    required
                                    disabled={!editarAgendamentos}
                                />
                            </div>

                            <div className="col-span-2">
                                <label
                                    htmlFor="last_name"
                                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('apelido')}*
                                </label>
                                <input
                                    type="text"
                                    value={apelidoR}
                                    id="phone"
                                    maxLength={60}
                                    className={` border  border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                        validacaoContacto
                                            ? 'dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500'
                                            : ''
                                    } ${
                                        !editarAgendamentos
                                            ? 'bg-gray-50 dark:bg-gray-800'
                                            : 'bg-white dark:bg-gray-900'
                                    }`}
                                    onChange={e => {
                                        setOnChangeForm(true);
                                        setApelidoR(e.target.value);
                                        setContactoR('');
                                        setValidacaoContacto(false);
                                    }}
                                    required
                                    disabled={!editarAgendamentos}
                                />
                            </div>
                            <div className="col-span-2">
                                <label
                                    htmlFor="last_name"
                                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {t('telefone')}*
                                </label>
                                <input
                                    type="text"
                                    id="phone"
                                    maxLength={20}
                                    value={telemovelR}
                                    className={` border  border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                        validacaoContacto
                                            ? 'dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500'
                                            : ''
                                    }${
                                        !editarAgendamentos
                                            ? 'bg-gray-50 dark:bg-gray-800'
                                            : 'bg-white dark:bg-gray-900'
                                    }`}
                                    onChange={e => {
                                        setOnChangeForm(true);
                                        setTelemovelR(e.target.value);
                                        setContactoR('');
                                        setValidacaoContacto(false);
                                    }}
                                    required
                                    disabled={!editarAgendamentos}
                                />
                            </div>
                        </div>
                    ) : null} */}
                    {/* {neg == '' && !empresaR && !contactoR ? (
                        <div>
                            <label
                                htmlFor="phone"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('contacto')}*
                            </label>
                            <input
                                type="text"
                                id="phone"
                                value={contactoSemNegocio}
                                maxLength={20}
                                className={` border  border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    validacaoContacto
                                        ? 'dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500'
                                        : ''
                                }${
                                    !editarAgendamentos
                                        ? 'bg-gray-50 dark:bg-gray-800'
                                        : 'bg-white dark:bg-gray-900'
                                }`}
                                onChange={e => {
                                    setOnChangeForm(true);
                                    setContactoSemNegocio(e.target.value);
                                    setValidacaoContacto(false);
                                }}
                                required
                                disabled={!editarAgendamentos}
                            />
                        </div>
                    ) : null} */}
                    <div className="mt-3">
                        <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('categoria')}*
                        </label>
                        <SelectComponent
                            isDisabled={!editarAgendamentos}
                            options={categorias}
                            value={categoria}
                            onChange={e => {
                                setOnChangeForm(true);
                                setCategoria(e);
                                setValidacaoCategoria(false);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                        {validacaoCategoria && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                    </div>
                    <div className="grid mt-3 gap-6 mb-3 md:grid-cols-4">
                        <div>
                            <label htmlFor="website" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('dataInicio')}*
                            </label>

                            <Datepicker
                                disabled={!editarAgendamentos}
                                displayFormat={FORMATO_DATA}
                                minDate={moment().format(FORMATO_DATA)}
                                useRange={false}
                                asSingle={true}
                                value={startDate}
                                onChange={newValue => {
                                    setOnChangeForm(true);
                                    setStartDate(newValue);
                                    setValidacaoDtI(false);
                                }}
                                inputClassName={`rounded-[8px] w-full  border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    validacaoDtI ? 'dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                                }${!editarAgendamentos ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'}`}
                            />
                        </div>
                        <div>
                            <label htmlFor="visitors" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('horaInicio')}*
                            </label>
                            <input
                                disabled={!editarAgendamentos}
                                maxLength={5}
                                type="time"
                                id="nome"
                                className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    validacaoHrI ? 'dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                                }${!editarAgendamentos ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'}
              `}
                                required
                                placeholder="00:00"
                                value={inputHoraInicial}
                                onChange={e => {
                                    setOnChangeForm(true);
                                    setInputHoraInicial(e.target.value);
                                    setValidacaoHrI(false);
                                }}
                                onBlur={e => {
                                    if (moment(endDate.startDate + ' ' + inputHoraFinal).isBefore(moment(startDate.startDate + ' ' + inputHoraInicial))) {
                                        setOnChangeForm(true);
                                        setInputHoraInicial(inputHoraFinal);
                                        setValidacaoHrF(false);
                                    }
                                }}
                            />
                        </div>
                        <div>
                            <label htmlFor="website" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('dataFim')}*
                            </label>

                            <Datepicker
                                disabled={!editarAgendamentos}
                                displayFormat={FORMATO_DATA}
                                minDate={startDate.startDate}
                                useRange={false}
                                asSingle={true}
                                value={endDate}
                                onChange={newValue => {
                                    setOnChangeForm(true);
                                    setEndDate(newValue);
                                    setValidacaoDtf(false);
                                }}
                                inputClassName={`rounded-[8px] w-full  border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    validacaoDtF ? 'dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                                } ${!editarAgendamentos ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'}`}
                            />
                        </div>
                        <div>
                            <label htmlFor="visitors" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                {t('horaFim')}*
                            </label>
                            <input
                                disabled={!editarAgendamentos}
                                maxLength={5}
                                type="time"
                                id="nome"
                                className={` border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 ${
                                    validacaoHrF ? 'dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                                }${!editarAgendamentos ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'}`}
                                value={inputHoraFinal}
                                onChange={e => {
                                    setOnChangeForm(true);
                                    setInputHoraFinal(e.target.value);
                                    setValidacaoHrF(false);
                                }}
                                onBlur={e => {
                                    if (moment(endDate.startDate + ' ' + inputHoraFinal).isBefore(moment(startDate.startDate + ' ' + inputHoraInicial))) {
                                        setOnChangeForm(true);
                                        setInputHoraFinal(inputHoraInicial);
                                        setValidacaoHrF(false);
                                    }
                                }}
                                required
                                placeholder="00:00"
                            />
                        </div>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('descricao')}*
                        </label>
                        <textarea
                            disabled={!editarAgendamentos}
                            id="message"
                            rows="1"
                            maxLength={250}
                            value={titulo}
                            onChange={e => {
                                setOnChangeForm(true);
                                setTitulo(e.target.value);
                                setValidacaoDesc(false);
                            }}
                            className={`block p-2.5 w-full text-sm text-gray-900  rounded-[8px] border border-gray-300 focus:ring-blue-500 focus:border-blue-500  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500  ${
                                validacaoDesc ? 'dark:border-red-500 dark:focus:ring-red-500 dark:focus:border-red-500 border-red-500 focus:ring-red-500 focus:border-red-500' : ''
                            }${!editarAgendamentos ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'}`}
                            placeholder={t('escrevaDescricao')}></textarea>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t('representante')}*
                        </label>
                        <SelectComponent
                            isDisabled={!editarAgendamentos}
                            options={responsaveis}
                            value={respRV}
                            onChange={e => {
                                setOnChangeForm(true);
                                setRespRV(e);
                                setValidacaoRep(false);
                            }}
                            noOptionsMessage={t('semopcoes')}
                            placeholder={t('selecioneOpcao')}
                        />
                        {validacaoRep && <p className="text-red-500 text-xs">{t('preenchaCampos')}</p>}
                    </div>
                    <button
                        className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-blue-600 rounded-[8px] text-sm w-8 h-8 absolute top-2.5 right-2.5 inline-flex items-center justify-center dark:hover:bg-blue-600 dark:hover:text-white"
                        onClick={() => {
                            setNovoContacto(false);
                        }}>
                        <ArrowBackRoundedIcon />
                    </button>
                </form>
            )}
            <ToastContainer />
        </>
    );
}

export default NovoAgendamento;
